$(function(){
	if ($('.crossSelling-container').length > 0){
		comprobarCrossSelling();

		$(window).resize(function() {
			comprobarCrossSelling();
		})
	}
})

function comprobarCrossSelling() {
	if (window.innerWidth < 800 && $('.crossSelling-container').find(".slick-list.draggable").length < 1){
		$('.crossSelling-container').slick({
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false
		});
	}
	else if (window.innerWidth > 799 && $('.crossSelling-container').find(".slick-list.draggable").length > 0) {
		$('.crossSelling-container').slick('unslick');
	}
}